import React, {Component} from 'react';
import {Link} from 'react-router';
import Translate from '../layout/Translate';

export default class Discount extends Component {


    componentWillMount() {


    }


    toggleDiscountInfo() {
        this.props.toggle();
    }

    render() {
        
        return (

            <div className={"popup " + (this.props.open?'popup_active':'')}>
                <div className="popup__window popup__window_discount discount-info">
                    <div className="popup__close" onClick={this.toggleDiscountInfo.bind(this)}></div>
                    <div className="discount-info__title">
                        <Translate slug="discount__title" />
                    </div>
                    <table className="sidebar__discount discount">
                        <tbody>
                        <tr className="sidebar__row ">
                            <td className="sidebar__period"><Translate slug="discount__6" /></td>
                            <td className="sidebar__period"><Translate slug="discount__8" /></td>
                            <td className="sidebar__period"><Translate slug="discount__10" /></td>
                        </tr>
                        <tr className="sidebar__row">
                            <td colSpan="3" className="sidebar__conditions">
                                <Translate slug="discount__pay" />
                            </td>
                        </tr>
                        <tr className="sidebar__row">
                            <td className="sidebar__percent sidebar__percent_5">5%</td>
                            <td className="sidebar__percent sidebar__percent_10">10%</td>
                            <td className="sidebar__percent sidebar__percent_20">20%</td>
                        </tr>
                        <tr className="sidebar__row">
                            <td colSpan="3" className="sidebar__conditions sidebar__conditions_middle">
                                <Translate slug="discount__prepay" />
                            </td>
                        </tr>
                        <tr className="sidebar__row">
                            <td className="sidebar__percent sidebar__percent_5">0</td>
                            <td className="sidebar__percent sidebar__percent_10">5%</td>
                            <td className="sidebar__percent sidebar__percent_20">10%</td>
                        </tr>
                        </tbody>
                    </table>
                    <p className="sidebar__info">
                        <Translate slug="discount__terms" />
                    </p>
                    <div className="disclaimer">
                        <Translate slug="discount__note" />
                    </div>

                </div>

                
            </div>


        );
    }
}



// WEBPACK FOOTER //
// ./src/common/components/popups/Discount.js